import React from "react";
import styled from "styled-components";

import theme from "../../../../Consts/Theme";
import { TextCustom } from "../../../../Components/Text/Text";
import useMediaCustom from "../../../../Hooks/useMediaCustom";

// styled-components
const StyledCardWrap = styled.div`
    margin-bottom: 16px;
  @media (max-width: 600px) {
    width: 100%;
    margin-bottom: 16px;
  }
`;
const StyledContainer = styled.article`
  border-radius: 16px;
  background-color: ${theme.danger_select};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 236px;

  div.img-box {
    display: flex;
    align-items: center;
    justify-content: end;
    align-self: flex-end;
    height: 198px;
  }

  div.badge {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    background: ${(props) => props.bgColor && props.bgColor};
    position: absolute;
    top: 8px;
    left: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: 600px) {
    width: 100%;
    padding: 16px;
    height: auto;
    min-height: 260px;
    flex-direction: column;
    img {

      justify-self: center;
      display: block;
    }

    div.badge {
      top: 16px;
      left: 16px;
    }
  }
  @media (min-width: 601px) and (max-width: 768px) {
    width: 210px;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    width: 234px;
  }
`;
const StyledAwardInfo = styled.div`
  padding-left: 10px;
  padding-top: 10px;

  p.award-title {
    width: 70%;
    margin-top: 6px;
  }

  @media (max-width: 600px) {
    width: 100%;
    align-self: flex-start;
    padding-left: 0px;
    padding-top: 0px;

    p.award-title {
      font-size: 14px;
      line-height: 17px;
    }
  }
`;

const AwardCard = ({ awardPlace, awardTitle, image, badgeBg, badgeColor }) => {
  const isLaptop = useMediaCustom("(min-width: 600px)");
  return (
    <StyledCardWrap>
      <StyledContainer bgColor={badgeBg}>
        <div className="badge">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M7.475 20.5003C6.09933 20.5003 4.92625 20.015 3.95575 19.0445C2.98525 18.074 2.5 16.9009 2.5 15.5253C2.5 14.2009 2.95192 13.0612 3.85575 12.106C4.75958 11.1509 5.87367 10.6374 7.198 10.5658C7.26217 10.5658 7.32633 10.5705 7.3905 10.58C7.4545 10.5897 7.51858 10.6009 7.58275 10.6138L4.58075 4.57528C4.42692 4.27411 4.43625 3.9812 4.60875 3.69653C4.78108 3.41186 5.03975 3.26953 5.38475 3.26953H8.698C9.04283 3.26953 9.35667 3.35995 9.6395 3.54078C9.92217 3.72161 10.1455 3.96261 10.3095 4.26378L12 7.65428L13.6905 4.26378C13.8545 3.96261 14.0778 3.72161 14.3605 3.54078C14.6433 3.35995 14.9572 3.26953 15.302 3.26953H18.6057C18.9506 3.26953 19.2108 3.41186 19.3865 3.69653C19.5622 3.9812 19.5731 4.27411 19.4193 4.57528L16.4423 10.5543C16.4999 10.5414 16.5592 10.5318 16.6202 10.5253C16.6811 10.5189 16.7436 10.5158 16.8077 10.5158C18.1283 10.5978 19.2404 11.1164 20.1443 12.0715C21.0481 13.0265 21.5 14.1694 21.5 15.5003C21.5 16.8926 21.0148 18.074 20.0443 19.0445C19.0738 20.015 17.8923 20.5003 16.5 20.5003C16.3308 20.5003 16.1574 20.4929 15.9798 20.478C15.8022 20.4634 15.6321 20.4329 15.4693 20.3868C16.3218 19.9149 16.9567 19.2335 17.374 18.3425C17.7913 17.4515 18 16.5041 18 15.5003C18 13.8246 17.4189 12.4057 16.2568 11.2435C15.0946 10.0814 13.6757 9.50028 12 9.50028C10.3243 9.50028 8.90542 10.0814 7.74325 11.2435C6.58108 12.4057 6 13.8246 6 15.5003C6 16.5246 6.19008 17.4984 6.57025 18.4215C6.95042 19.3445 7.59883 19.9996 8.5155 20.3868C8.34617 20.4329 8.17433 20.4634 8 20.478C7.82567 20.4929 7.65067 20.5003 7.475 20.5003ZM12 20.0003C10.75 20.0003 9.6875 19.5628 8.8125 18.6878C7.9375 17.8128 7.5 16.7503 7.5 15.5003C7.5 14.2503 7.9375 13.1878 8.8125 12.3128C9.6875 11.4378 10.75 11.0003 12 11.0003C13.25 11.0003 14.3125 11.4378 15.1875 12.3128C16.0625 13.1878 16.5 14.2503 16.5 15.5003C16.5 16.7503 16.0625 17.8128 15.1875 18.6878C14.3125 19.5628 13.25 20.0003 12 20.0003ZM12 16.7253L13.148 17.5925C13.2417 17.663 13.3321 17.6656 13.4193 17.6003C13.5064 17.5349 13.5333 17.4504 13.5 17.3465L13.0635 15.9175L14.202 15.1003C14.2955 15.0298 14.3256 14.9452 14.2923 14.8465C14.2589 14.7477 14.1852 14.6983 14.0712 14.6983H12.6673L12.2213 13.1888C12.1879 13.0849 12.1142 13.033 12 13.033C11.8858 13.033 11.8121 13.0849 11.7788 13.1888L11.3328 14.6983H9.92875C9.81475 14.6983 9.74108 14.7477 9.70775 14.8465C9.67442 14.9452 9.7045 15.0298 9.798 15.1003L10.9365 15.9175L10.5 17.3465C10.4667 17.4504 10.4936 17.5349 10.5808 17.6003C10.6679 17.6656 10.7583 17.663 10.852 17.5925L12 16.7253Z"
              fill={badgeColor}
            />
          </svg>
        </div>
        <div className="img-box">
          <img src={image} alt={awardTitle} />
        </div>
        {!isLaptop ? (
          <StyledAwardInfo>
            <TextCustom
              fontSize="14"
              lineHeight="16"
              fontWeight={500}
              color={theme.gray2}
            >
              {awardPlace}
            </TextCustom>
            <TextCustom
              fontSize="17"
              lineHeight="20"
              fontWeight={600}
              color={theme.darkBlack}
              className="award-title"
            >
              {awardTitle}
            </TextCustom>
          </StyledAwardInfo>
        ) : (
          ""
        )}
      </StyledContainer>
      {isLaptop ? (
        <StyledAwardInfo>
          <TextCustom
            fontSize="14"
            lineHeight="16"
            fontWeight={500}
            color={theme.gray2}
          >
            {awardPlace}
          </TextCustom>
          <TextCustom
            fontSize="17"
            lineHeight="20"
            fontWeight={600}
            color={theme.darkBlack}
            className="award-title"
          >
            {awardTitle}
          </TextCustom>
        </StyledAwardInfo>
      ) : (
        ""
      )}
    </StyledCardWrap>
  );
};

export default AwardCard;
